import { fromInteger } from '@repo/money'
import type { InventoryItem, Booster, Bonus } from '../types/domain'
import type { InventoryItemDto } from '../types/dto'

export const fromInventoryItemDTO = (dto: InventoryItemDto): InventoryItem => {
  const baseProps = {
    id: dto.id,
    playerId: dto.playerId,
    status: dto.status,
    createdAt: dto.createdAt,
    expiresAt: dto.expiresAt,
    claimedAt: dto.claimedAt,
    applicableGames: dto.applicableGames,
    quantity: dto.quantity,
    tags: dto.tags,
    originType: dto.originType,
    originId: dto.originId
  }

  if (dto.type === 'booster' && dto.boost && dto.activationType) {
    const booster: Booster = {
      ...baseProps,
      type: 'booster',
      boost: {
        value: dto.boost.value,
        unit: dto.boost.unit
      },
      activationType: dto.activationType
    }
    return booster
  }

  if (dto.type === 'free_bet' && dto.amount && dto.currency) {
    const bonus: Bonus = {
      ...baseProps,
      type: 'bonus',
      amount: fromInteger(dto.amount, dto.currency),
      currency: dto.currency
    }
    return bonus
  }

  throw new Error(`Unknown inventory item type: ${dto.type}`)
}

export const fromInventoryItemsDTO = (dtos: InventoryItemDto[]): InventoryItem[] => {
  return dtos.map(fromInventoryItemDTO)
}
